<template>
    <section class="footer-section">
        <div class="footer-section__row">
            <div class="contacts-title">CONTACTS</div>
            <div class="content-wrapper">
                <div class="footer-message-group">
                    <div class="footer-message">
                        <p>Let&rsquo;s talk and explore how we can drive success together!</p>
                        <a href="https://kendoo.com" target="_blank" rel="noopener noreferrer">https://kendoo.com</a>
                    </div>
                    <div class="social-icons">
                        <a href="https://im.linkedin.com/company/kendooplay" target="_blank" rel="nofollow noopener noreferrer">
                            <img src="@/assets/img/tournaments/demo-stand/social-linkedin-icon-v2.svg"/>
                        </a>
                    </div>
                </div>
                <div class="footer-contacts">
                    <div class="footer-contacts__item">
                        <img src="@/assets/img/tournaments/demo-stand/icon-map-pin.svg" alt=""/>
                        <span>Third Floor, 34 Hope Street, Douglas, Isle of Man, IM1 1AP</span>
                    </div>
                    <div class="footer-contacts__item">
                        <img src="@/assets/img/tournaments/demo-stand/icon-send.svg" alt=""/>
                        <span>saleskendoo</span>
                    </div>
                    <div class="footer-contacts__item">
                        <img src="@/assets/img/tournaments/demo-stand/icon-mail.svg" alt=""/>
                        <span>
                          <a
                              class="footer-contacts__item"
                              href="mailto:sales@kendoo.com"
                          >
                            sales@kendoo.com
                          </a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer__bottom">
            <div>
                <p><a href="/static/media/privacy_policy.pdf" target="_blank">Privacy Policy</a></p>
            </div>
            <div>
                <p>© {{ year }} KENDOO. All Rights Reserved</p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "TournamentFooterSection",

    data() {
        return {
            year: new Date().getFullYear()
        }
    },
}
</script>

